import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { getClients } from 'apis/UserAPI';
import { ActionPlanDetailsType } from 'types/actionPlans';
import { PaginatedResponseType } from 'types/common';
import { UserActorType } from 'types/user';

import { buildOwnerOptions } from './formUtils';

const ACTION_PLAN_OWNER_USERS_PAGE_SIZE = 100;

const getActionPlanOwnerUsers = async (companyId: number): Promise<UserActorType[]> => {
  const users: UserActorType[] = [];
  let page = 1;
  let hasNextPage = true;

  while (hasNextPage) {
    const response = (await getClients({
      company: companyId,
      is_active: true,
      page,
      page_size: ACTION_PLAN_OWNER_USERS_PAGE_SIZE,
    })) as PaginatedResponseType<UserActorType>;

    users.push(...(response.results ?? []));
    hasNextPage = Boolean(response.next);
    page += 1;
  }

  return users;
};

const useActionPlanOwnerOptions = (companyId?: number, details?: ActionPlanDetailsType | null) => {
  const { data: ownerUsers } = useQuery({
    queryKey: ['action-plans-users', companyId],
    queryFn: () => getActionPlanOwnerUsers(companyId as number),
    enabled: Boolean(companyId),
    refetchOnWindowFocus: false,
  });

  return useMemo(() => buildOwnerOptions(ownerUsers, details), [details, ownerUsers]);
};

export default useActionPlanOwnerOptions;
